<template>
    <v-container fluid grid-list-md>
        <v-layout row wrap>
            <v-flex xs12>
                <v-card>
                     <v-card-text>
                         <v-container fluid v-if="reservation.show || 1">
                              <v-layout row wrap>
                                    <v-col cols="12">
                                        <label for="internalNotes">Internal Notes</label>
                                    </v-col>

                                    <v-col cols="12">
                                        <textarea type="text" 
                                            id="internalNotes"
                                            name="internalNotes"
                                            v-model="internalNotes"></textarea>
                                  </v-col>
                              </v-layout>
                          </v-container>
                      </v-card-text>

                      <v-card-actions>
                          <v-btn class="" 
                              disabled 
                              v-on:click="cancel"
                              title="Cancel without changes">Cancel</v-btn>
                          <v-btn
                              title="Save the changes to the reservation"
                              v-on:click="saveChanges">Save</v-btn>
                      </v-card-actions>
                 </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    /**
     * A Vue component dedicated to letting the user update itnernal notes for a reservation
     *
     * Props:
     *     int 'reservationkey' - The ID of the reservation to display
     */
    import axios from 'axios';
    // Import the application event bus so we can listen for data changes and react accordingly
    import EventBus from '@/eventBus';
    export default {
        name: 'hotel-reservation-internal-notes',
        props: ['reservationkey'],
        data () {
            return {
                internalNotes: "",
                reservation: {},
            }
        },
        methods: {

            /**
             * Register event listener that will be listening for clearSelector event to clear it's selected state
             */
            setUpEventListeners() {
                EventBus.$on('Reservation Administration: Reservation changed', this.onReservationChanged);
            },

            /**
             * @method onReservationChanged
             * 
             * Respond to the reservation having been edited
             * by checking if the event is talking about this reservation,
             * and if so then reload it afresh so we are displaying all of
             * the correct data across the board
             * 
             * @param payload 
             */
            onReservationChanged(payload){
                if (payload.reservationKey == this.reservationkey){
                   this.loadReservation();
                }
            },

            loadReservation(){
                axios.get('/api/reservations/id/' + this.reservationkey)
                .then(function(response){
                    this.reservation = response.data.reservation;
                    this.internalNotes = this.reservation.internal_notes;
                }.bind(this));
            },

            /**
             * Push the changes up to the server
             */
            saveChanges(){
                var params = {
                    "internalNotes": this.internalNotes
                };
                axios.post('/api/reservation/' + this.reservationkey + '/set-notes', params)
                .then(function(response){
                    alert("Notes updated");
                    EventBus.$emit('Reservation Administration: Reservation changed', {'reservationKey': this.reservationkey});
                }.bind(this));
            },

            cancel(){
                // Do what when backing out of it?
            },
        },

        /**
         * Once mounted this component needs to load the reservation specified
         */
        mounted() {
            this.loadReservation();
            this.setUpEventListeners();
        },

        computed: {}
    }
</script>

